import React from 'react';

import { Alert, Button, Stack, Typography } from '@mui/material';

import { useGetReportingLeLens } from '~/hooks/apis/reporting/useGetReportingLeLens';

import { isCardLens } from '~/types/leLens';

import { lensIdFromPath, lensPath } from '../lensPath';
import { SHELL_LENS_PARAM } from '../shellUrlState';

import { unboundCards } from './createdLensReceipt';

type Props = {
  lensId: string;
  onOpenLens?: (lensId: string) => void;
};

export default function LensCreatedReceipt({ lensId, onOpenLens }: Props) {
  const { data: response } = useGetReportingLeLens(lensId);
  const data = response && isCardLens(response.lens) ? { ...response, lens: response.lens } : undefined;
  const cards = unboundCards(data?.lens.spec.cards ?? []);
  if (!data?.lens) return null;
  const onScreen =
    (lensIdFromPath(window.location.pathname) ?? new URLSearchParams(window.location.search).get(SHELL_LENS_PARAM)) ===
    lensId;
  const openButton = !onScreen ? (
    <Button
      href={onOpenLens ? undefined : lensPath(lensId)}
      onClick={onOpenLens ? () => onOpenLens(lensId) : undefined}
      size="small"
      variant="text"
    >
      Open Lens
    </Button>
  ) : null;
  if (!cards.length) return openButton;
  const titles = cards.map((card) => card.title).join(', ');
  return (
    <Alert severity="warning">
      <Stack alignItems="flex-start" spacing={1}>
        <Typography variant="body2">
          {cards.length === 1
            ? `${titles} isn’t connected to data yet.`
            : `${cards.length} cards aren’t connected to data yet: ${titles}.`}
        </Typography>
        {openButton}
      </Stack>
    </Alert>
  );
}
